import React from 'react';
import { SelectProps } from '../types';
import styles from './Select.module.scss';

export const Select: React.FC<SelectProps> = ({
  label,
  value,
  onChange,
  options = [],
  error,
  helperText,
  required = false,
  placeholder = 'Select an option',
  fullWidth = true,
  className = '',
  ...props
}) => {
  const containerClasses = [
    styles.selectContainer,
    fullWidth ? styles.fullWidth : '',
    className
  ].filter(Boolean).join(' ');

  const selectClasses = [
    styles.select,
    error ? styles.error : ''
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClasses}>
      {label && (
        <label className={styles.label}>
          {label}
          {required && <span className={styles.required}> *</span>}
        </label>
      )}
      <select
        value={value}
        onChange={onChange}
        className={selectClasses}
        {...props}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && <span className={styles.errorText}>{error}</span>}
      {!error && helperText && <span className={styles.helperText}>{helperText}</span>}
    </div>
  );
};
